import { friendlyError } from '../../utils/userMessages';
import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { CheckCircle, WarningAmber, Login } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyProfessionalEmailToken } from '../../services/api/platformIntegrationService';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [state, setState] = useState({ status: 'loading', message: 'Verifying your email…' });

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = params.get('token') || '';
    if (!token) {
      setState({ status: 'error', message: 'This verification link is missing its secure token.' });
      return;
    }
    verifyProfessionalEmailToken(token)
      .then((result) => setState({ status: 'success', message: `${result?.email || 'Your email'} is verified. You can now sign in.` }))
      .catch((error) => setState({ status: 'error', message: friendlyError(error, 'This verification link is invalid or expired.') }));
  }, [params]);

  const success = state.status === 'success';
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, background: 'linear-gradient(145deg,#EDF5F8,#F9FBFC 48%,#E8F5F0)' }}>
      <Paper elevation={0} sx={{ width: 'min(520px,100%)', p: { xs: 3, md: 4.5 }, borderRadius: 5, border: '1px solid rgba(31,62,82,.10)', boxShadow: '0 28px 80px -38px rgba(31,62,82,.38)', textAlign: 'center' }}>
        <Box sx={{ width: 72, height: 72, borderRadius: 4, display: 'grid', placeItems: 'center', mx: 'auto', mb: 2.5, bgcolor: success ? '#E3F3EC' : state.status === 'error' ? '#FBE7E6' : '#E4F0F6', color: success ? '#2E8B69' : state.status === 'error' ? '#BC3A36' : '#2E6F8E' }}>
          {state.status === 'loading' ? <CircularProgress size={30} /> : success ? <CheckCircle sx={{ fontSize: 38 }} /> : <WarningAmber sx={{ fontSize: 38 }} />}
        </Box>
        <Typography sx={{ fontWeight: 900, fontSize: '1.45rem', color: '#182235' }}>{success ? 'Email verified' : state.status === 'error' ? 'Verification problem' : 'Verifying email'}</Typography>
        <Typography sx={{ mt: 1, color: '#4F6175', lineHeight: 1.65 }}>{state.message}</Typography>
        {state.status !== 'loading' && <Button variant="contained" startIcon={<Login />} onClick={() => navigate('/login', { replace: true })} sx={{ mt: 3, borderRadius: 2.5, px: 3, py: 1.1, textTransform: 'none', fontWeight: 800, bgcolor: '#2E6F8E' }}>Go to login</Button>}
      </Paper>
    </Box>
  );
}
